// «Sugeridos» when assigning a contractor: the providers whose free-text
// specialty mentions the observation's category label, then everyone
// else. One copy for the desktop assign drawer
// (apps/web-dashboard/src/components/AssignBatchDrawer.tsx) and the
// PWA's Gestión sheet (T-qvnj), so both suggest the same people.
//
// A substring match on purpose: `providers.specialty` is operator text
// («Gasfitería y clima»), not a key. Not barrel-exported from ./index.ts
// for the same reason as ./relative-time — import it from the
// "@bitacorapro/shared/provider-suggestions" subpath so the PWA bundle
// stays off the zod/pino barrel.
export function splitProvidersBySpecialty(providers, specialtyLabel) {
    const needle = specialtyLabel?.trim().toLowerCase();
    if (!needle)
        return { suggested: [], rest: [...providers] };
    const matches = (p) => (p.specialty ?? "").toLowerCase().includes(needle);
    return {
        suggested: providers.filter(matches),
        rest: providers.filter((p) => !matches(p)),
    };
}
//# sourceMappingURL=provider-suggestions.js.map